<template>
  <b-table v-bind="tableAttributes" :fields="fields" :items="items">

    <template #cell(title)="data" class="w-50 p-0">
      <span class="text-wrap p-0">
      {{ data.item.title }}
      </span>
    </template>
    <template #cell(thumbnail)="data">
      <b-img :src="data.item.thumbnail" v-bind="mainProps"/>
    </template>


    <template #cell(status)="data">
      <status-changer item-type="content" :item="data.item"/>
    </template>

    <template #cell(free)="data">
      <b-badge v-if="data.item.free == 1 " variant="success" class="m-0"
      >رایگان
      </b-badge
      >
      <b-badge v-else variant="danger">غیر رایگان</b-badge>
    </template>

    <template #cell(courses)="data">
      <span class="text-wrap badge badge-warning" v-for="course in data.item.courses">{{ course.title }}</span>
    </template>

    <template #cell(action)="data">
      <div v-if="restoreState == true">
        <span
            class="h4"
            v-b-tooltip.hover
            title="حذف دائمی"

        >
        <b-icon icon="trash" @click="ForceDeleteContent(data.item)"></b-icon>
      </span>

        <span
            class="h4"
            v-b-tooltip.hover
            title="بازگردانی"
        >
        <b-icon
            icon="arrow-clockwise"
            class="mr-3"
            @click="restore(data.item)"
        ></b-icon>
      </span>


      </div>
      <div>

        <span class="h4 " v-b-tooltip.hover title="حذف">
        <b-icon icon="trash" class="m-3" @click="deleteContent(data.item)"></b-icon>
      </span>

        <span class="h4  text-dark" v-b-tooltip.hover title="ویرایش">
        <router-link class="text-dark"
                     :to="{ name: 'UpdateLessons', params: { slug: data.item.slug } }"
        >
          <b-icon icon="pencil" class="m-3 mx-4"></b-icon>
        </router-link>
      </span>

        <duplicate-item :item="data.item" item-type="lesson"/>

      </div>
    </template>
  </b-table>
</template>

<script>
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import StatusChanger from "../../genralComponents/StatusChanger";
import DuplicateItem from "../../genralComponents/DuplicateItem";

export default {
  name: "tableItems",
  components: {StatusChanger, DuplicateItem,},
  props: ["items", "restoreState"],
  data() {
    return {
      tableAttributes,
      fields: [
        {key: "thumbnail", label: "عکس"},
        {key: "title", label: "عنوان"},
        {key: "status", label: "وضعیت"},
        {key: "free", label: "نوع درس"},
        {key: "courses", label: "دوره های مرتبط"},
        {key: "action", label: ""},
      ],
      mainProps: {width: 75, height: 75, class: 'p-0 rounded'}
    };
  },
  methods: {
    formatNumber,
    statusState(status) {
      if (status == 1) {
        return true;
      } else {
        return false;
      }
    },
    deleteContent(item) {
      if (confirm('آیا از حذف اطمینان دارید؟')) {
        this.$store.dispatch("Content/deleteContent", item);
      }
    },
    restore(item) {
      if (confirm(' بازگردانی  شود؟')) {
        this.$store.dispatch("Content/restoreContent", item.id);
      }
    },
    ForceDeleteContent(item) {
      if (confirm('آیا از حذف  دائمی اطمینان دارید؟')) {
        this.$store.dispatch("Content/forceDeleteContent", item);
      }
    },
  },
};
</script>